var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundRinginline = function SvgRoundRinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#231F20",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    clipPath: "url(#RoundRing_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.154 4.007 3.634 1.291 1.674 3.826-1.387 3.825-3.92 1.579-3.779-1.579L3.99 9.506 5.376 5.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.101.137 6.308 2.241 2.905 6.64-2.407 6.64-6.806 2.74-6.557-2.74L.137 9.682 2.544 2.71zM9.101.137l.053 3.87M15.41 2.378l-2.622 2.92M14.462 9.124l3.852-.106M13.075 12.95l2.832 2.708M9.154 14.528l-.053 3.87M5.376 12.95l-2.832 2.708M3.99 9.506l-3.853.176M5.376 5.49 2.544 2.71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "RoundRing_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18.453v18.536H0z"
  })))));
};
export default SvgRoundRinginline;